class StockToggle extends HTMLElement {
  constructor() {
    super();
  }

  onClick() {
    this.inStockCheckbox.listOnClick();
    this.updateState();
  }

  onCheckboxClick() {
    this.updateState();
  }

  updateState() {
    this.isActive = this.inStockCheckbox.getAttribute("data-filter-active") === "true";

    if (this.isActive) {
      this.setAttribute("data-checked", "");
      return;
    }
    this.removeAttribute("data-checked");
  }

  connectedCallback() {
    // Checkbox node
    this.inStockCheckbox = document.querySelector("wdn-filter[data-id='filter.v.availability1']");

    // State
    this.updateState();

    // Self click
    this.addEventListener("click", this.onClick.bind(this));

    // Checkbox click
    this.inStockCheckbox.addEventListener("click", this.onCheckboxClick.bind(this));

    // Listen for fetch success
    document.addEventListener("filters:fetch:success", this.updateState.bind(this));
  }
}

customElements.define("stock-toggle", StockToggle);
